import { Link } from "react-router-dom";
import { Footer } from "@/components/Footer";
import { Navbar } from "@/components/Navbar";

const identity = [
  ["Nombre de dominio", "www.analytics4people.com"],
  ["Nombre comercial", "ANALYTICS 4 PEOPLE"],
  ["Denominación social", "ANALYTICS 4 PEOPLE SLU"],
  ["NIF", "B56823453"],
  ["Domicilio social", "C/ Escudillers 6, 17761 Cabanes (Girona)"],
  ["Teléfono", "+34 687 447 999"],
  ["E-mail", "a4p@analytics4people.com"],
  ["Datos registrales", "Girona; tomo 3468; libro 0; folio 161; sección 8; hoja GI74115; inscripción 1."],
];

const sections = [
  {
    title: "LEY DE LOS SERVICIOS DE LA SOCIEDAD DE LA INFORMACIÓN (LSSI)",
    paragraphs: [
      "ANALYTICS 4 PEOPLE SLU, responsable del sitio web, pone a disposición de los usuarios este documento para informar sobre las condiciones de uso del sitio.",
      "Toda persona que acceda a este sitio web asume el papel de usuario y se compromete a cumplir las disposiciones aquí indicadas y las demás que resulten de aplicación.",
      "ANALYTICS 4 PEOPLE SLU puede modificar la información publicada en el sitio web. La publicación de los cambios en el propio sitio será suficiente para informar de ellos.",
    ],
  },
  {
    title: "DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL",
    paragraphs: [
      "El sitio web, incluidos su programación, diseño, logotipos, textos y gráficos, pertenece al responsable o se utiliza con licencia o autorización de sus titulares. Sus contenidos están protegidos por la normativa de propiedad intelectual e industrial.",
      "La reproducción, uso, explotación, distribución o comercialización total o parcial de estos contenidos requiere autorización previa y por escrito del responsable, salvo que la normativa aplicable disponga otra cosa.",
      "Los diseños, logotipos, textos y gráficos de terceros que puedan aparecer en el sitio pertenecen a sus respectivos titulares. Su aparición no implica respaldo ni responsabilidad del responsable sobre ellos.",
      "Para comunicar posibles incumplimientos relativos a derechos de propiedad intelectual o al contenido del sitio, escribe a a4p@analytics4people.com.",
    ],
  },
  {
    title: "EXENCIÓN DE RESPONSABILIDADES",
    paragraphs: [
      "El responsable no será responsable de la información publicada en el sitio cuando haya sido manipulada o introducida por terceros ajenos y no tenga conocimiento efectivo de ello, o cuando, una vez conocido, haya actuado diligentemente para retirar los datos o impedir el acceso.",
    ],
  },
  {
    title: "USO DE COOKIES",
    paragraphs: [
      "Este sitio puede utilizar cookies y tecnologías similares para recordar las preferencias y permitir el funcionamiento de sus servicios. Las categorías, finalidades y opciones de gestión se explican en la política de cookies.",
    ],
  },
  {
    title: "POLÍTICA DE ENLACES",
    paragraphs: [
      "El sitio puede incluir enlaces a páginas de terceros. El responsable no controla sus contenidos y no asume responsabilidad por ellos. Si recibe información de que un contenido enlazado puede ser contrario a la ley, la moral o el orden público, actuará para retirar el enlace cuando corresponda.",
      "Si consideras que existe en este sitio contenido que deba revisarse, puedes comunicarlo a a4p@analytics4people.com.",
      "El sitio se revisa para procurar su correcto funcionamiento. Aun así, pueden producirse errores técnicos o circunstancias que impidan temporalmente el acceso.",
    ],
  },
  {
    title: "DIRECCIONES IP",
    paragraphs: [
      "Al conectarse al sitio, los servidores pueden recibir datos técnicos de la conexión, como la dirección IP y el nombre de dominio, para entregar el contenido y mantener la seguridad y operación del servicio.",
    ],
  },
  {
    title: "LEY APLICABLE Y JURISDICCIÓN",
    paragraphs: [
      "Las cuestiones relacionadas con este sitio web y las actividades desarrolladas en él se rigen por la legislación española, sin perjuicio de las normas imperativas que resulten aplicables. La competencia corresponderá a los juzgados y tribunales que determine la normativa vigente.",
    ],
  },
];

export default function LegalNotice() {
  return (
    <div data-testid="legal-notice-page" className="min-h-screen bg-[#FAFAFD] text-[#353535]">
      <Navbar />
      <main className="px-5 sm:px-8 pt-36 pb-24 sm:pt-44">
        <article className="mx-auto max-w-4xl font-jakarta">
          <div className="font-jbmono text-[11px] uppercase tracking-[0.3em] text-[#4361ee] mb-6">Información legal</div>
          <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl leading-tight">Aviso legal</h1>
          <div className="mt-12 space-y-10 text-sm leading-7 text-[#353535]/75">
            {sections.map((section) => (
              <section key={section.title}>
                <h2 className="mb-4 text-base font-bold text-[#353535]">{section.title}</h2>
                {section.paragraphs.map((paragraph) => <p key={paragraph} className="mb-3">{paragraph}</p>)}
                {section.title === "USO DE COOKIES" && (
                  <p><Link className="font-semibold text-[#4361ee] underline underline-offset-4" to="/cookies/policy">Consulta la política de cookies.</Link></p>
                )}
              </section>
            ))}
            <section>
              <h2 className="mb-4 text-base font-bold text-[#353535]">DATOS IDENTIFICATIVOS</h2>
              <dl className="divide-y divide-black/10">
                {identity.map(([label, value]) => (
                  <div key={label} className="grid gap-1 py-3 sm:grid-cols-[200px_1fr]">
                    <dt className="font-semibold text-[#353535]">{label}</dt>
                    <dd className="m-0">{value}</dd>
                  </div>
                ))}
              </dl>
            </section>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
